/**
 * Изучаемый язык добавлен, а программы для него ещё нет: вместо карты и
 * следующего урока — честное «курс готовится» и путь к другому языку.
 */

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LANGUAGE_FLAGS, type LanguageCode } from '@aptile/shared';

import { Button } from './Button';
import { Quokka } from './Quokka';

export function CourseComingSoon({ language, compact = false }: { readonly language: LanguageCode; readonly compact?: boolean }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={`flex flex-col gap-3 ${compact ? '' : 'items-center py-6 text-center'}`}>
      {!compact && <Quokka mood="thinking" alt="" size="lg" />}
      <span className="font-heading text-xs font-bold uppercase tracking-wide text-teal-deep">
        <span aria-hidden="true">{LANGUAGE_FLAGS[language]} </span>
        {t(`languages.names.${language}`)}
      </span>
      <p className="font-heading text-xl font-extrabold text-heading">{t('learning.comingSoonTitle')}</p>
      <p className="max-w-md text-sm text-muted">{t('learning.comingSoonText')}</p>
      <Button variant="secondary" onClick={() => navigate('/profile')}>
        {t('learning.chooseLanguage')}
      </Button>
    </div>
  );
}
